module.exports = __webpack_public_path__ + "img/DP358.9515431e.png";